/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC } from 'react'
import { useIntl } from 'react-intl'
import { KTIcon } from 'src/_metronic/helpers'
import { PageTitle } from 'src/_metronic/layout/core'
import { CardNav } from 'src/app/helpers/components/cards/CardNav'

const DesignPage: FC = () => {
  const intl = useIntl()
  return (
    <>
      {/* begin::Row */}
      <div className='row g-5 g-xl-10 mb-5 mb-xl-10'>
        <div className='col-12'>
          <div className='card shadow-sm'>
            <div className='card-header py-5 border-0'>
              <h6 className='card-title d-flex align-items-center my-0'>
                <span className='symbol symbol-circle symbol-50'>
                  <span className='symbol-label'>
                    <KTIcon iconName='category' className='fs-1' />
                  </span>
                </span>
                <span className='ms-5 d-inline-block'>
                  {intl.formatMessage({ id: 'MENU.DESIGN.LIBRARY_PROFILE' })}
                </span>
              </h6>
            </div>
            <div className='card-body bg-light rounded-bottom pb-0'>
              <div className='row'>
                <div className='col-6 col-md-4 col-lg-3 col-xl-3 col-xxl-3 mb-md-5 mb-xl-10 h-100'>
                  <CardNav
                    to='./lib-profile/record-profile-design'
                    kticon='tablet-text-down'
                    title={intl.formatMessage({
                      id: 'MENU.DESIGN.LIBRARY_PROFILE.RECORD_PROFILE_DESIGN',
                    })}
                  />
                </div>
                <div className='col-6 col-md-4 col-lg-3 col-xl-3 col-xxl-3 mb-md-5 mb-xl-10 h-100'>
                  <CardNav
                    to='./lib-profile/fields-lookup'
                    kticon='element-2'
                    title={intl.formatMessage({
                      id: 'MENU.DESIGN.LIBRARY_PROFILE.FIELDS_LOOKUP',
                    })}
                  />
                </div>
                {/* <div className='col-6 col-md-4 col-lg-3 col-xl-3 col-xxl-3 mb-md-5 mb-xl-10 h-100'>
                  <CardNav
                    to='./lib-profile/master-data-lookup'
                    kticon='element-9'
                    title={intl.formatMessage({
                      id: 'MENU.DESIGN.LIBRARY_PROFILE.MASTER_DATA_LOOKUP',
                    })}
                  />
                </div> */}
                <div className='col-6 col-md-4 col-lg-3 col-xl-3 col-xxl-3 mb-md-5 mb-xl-10 h-100'>
                  <CardNav
                    to='./lib-profile/document-type'
                    kticon='element-9'
                    title={intl.formatMessage({
                      id: 'MENU.DESIGN.LIBRARY_PROFILE.DOCUMENT',
                    })}
                  />
                </div>
                <div className='col-6 col-md-4 col-lg-3 col-xl-3 col-xxl-3 mb-md-5 mb-xl-10 h-100'>
                  <CardNav
                    to='./lib-profile/master-data-lookup'
                    kticon='setting-2'
                    title={intl.formatMessage({
                      id: 'MENU.DESIGN.LIBRARY_PROFILE.LIBRARY_ACCESS_SETTING',
                    })}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className='col-12'>
          <div className='card shadow-sm'>
            <div className='card-header py-5 border-0'>
              <h6 className='card-title d-flex align-items-center my-0'>
                <span className='symbol symbol-circle symbol-50'>
                  <span className='symbol-label'>
                    <KTIcon iconName='share' className='fs-1' />
                  </span>
                </span>
                <span className='ms-5 d-inline-block'>
                  {intl.formatMessage({ id: 'MENU.DESIGN.PROCESS' })}
                </span>
              </h6>
            </div>
            <div className='card-body bg-light rounded-bottom pb-0'>
              <div className='row'>
                <div className='col-6 col-md-4 col-lg-3 col-xl-3 col-xxl-3 mb-md-5 mb-xl-10 h-100'>
                  <CardNav
                    to='./process/process-list'
                    kticon='questionnaire-tablet'
                    title={intl.formatMessage({
                      id: 'MENU.DESIGN.PROCESS.PROCESS_LIST',
                    })}
                  />
                </div>
                <div className='col-6 col-md-4 col-lg-3 col-xl-3 col-xxl-3 mb-md-5 mb-xl-10 h-100'>
                  <CardNav
                    to='./process/process-access'
                    kticon='setting-2'
                    title={intl.formatMessage({
                      id: 'MENU.DESIGN.PROCESS.PROCESS_ACCESS',
                    })}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* end::Row */}
    </>
  )
}

const DesignWrapper: FC = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle>{intl.formatMessage({ id: 'MENU.DESIGN' })}</PageTitle>
      <DesignPage />
    </>
  )
}

export { DesignWrapper }
